export default "__VITE_ASSET__LSdubMd6__"